export default "__VITE_ASSET__Br2VMoAw__"